// Generate a random upload key for anonymous album uploads
export const generateUploadKey = () => {
  // Generate a 24-character random key using crypto API
  const array = new Uint8Array(18); // 18 bytes = 24 base64 characters
  crypto.getRandomValues(array);

  // Convert to base64url (URL-safe base64)
  return btoa(String.fromCharCode(...array))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
};
